var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart-template__footer-attributes" }, [
    _c("div", { staticClass: "cart-template__packaging" }, [
      _c(
        "p",
        { staticClass: "body-small", attrs: { id: "complimentary-packaging" } },
        [_vm._v("\n      " + _vm._s(_vm.packagingLabel) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cart-template__packaging-options" },
        _vm._l(_vm.packagingOptions, function(option, index) {
          return _c(
            "button",
            {
              key: index,
              class: { active: option === _vm.selectedPackaging },
              attrs: {
                type: "button",
                "aria-labelledby": "complimentary-packaging"
              },
              on: {
                click: function($event) {
                  return _vm.updatePackaging(index)
                }
              }
            },
            [_vm._v("\n        " + _vm._s(option) + "\n      ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedPackaging,
            expression: "selectedPackaging"
          }
        ],
        attrs: { type: "hidden", name: "attributes[packaging]" },
        domProps: { value: _vm.selectedPackaging },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.selectedPackaging = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.displayNote
      ? _c(
          "div",
          { staticClass: "cart-template__note" },
          [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                {
                  staticClass: "form-group__control",
                  class: _vm.selectionStatus
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.addNote,
                        expression: "addNote"
                      }
                    ],
                    staticClass: "input--checkbox",
                    attrs: {
                      id: "add-note",
                      type: "checkbox",
                      name: "add-note"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.addNote)
                        ? _vm._i(_vm.addNote, null) > -1
                        : _vm.addNote
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.addNote,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.addNote = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.addNote = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.addNote = $$c
                          }
                        },
                        _vm.addNoteOption
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "add-note" } }, [
                    _vm._v(_vm._s(_vm.addNoteText))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-vertical" } }, [
              _vm.addNote
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label visually-hidden",
                        attrs: { for: "cart-note" }
                      },
                      [_vm._v(_vm._s(_vm.cartNoteLabel))]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.note,
                          expression: "note"
                        }
                      ],
                      attrs: { id: "cart-note", name: "note" },
                      domProps: { value: _vm.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.note = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }